import Vue from 'vue';
import Headful from 'vue-headful';
import Notifications from 'vue-notification';
import Resource from 'vue-resource';
import VueAnalytics from 'vue-analytics';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(Notifications);
Vue.use(Resource);
Vue.use(VueAnalytics, {
  id: 'UA-138480453-2',
  router
});
Vue.component('Metadata', Headful);

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    if (this.$store.state.user) {
      this.$http.get(`/api/users/${this.$store.state.user}/reset`)
        .then((response) => {
          const forceLogout = response.data;

          if (!forceLogout) {
            return;
          }

          store.commit('logout');
          router.push({
            name: 'loginIndex',
            params: {
              error: 'Reporting app has been updated. Please login again to grab the latest changes.',
            },
          });
        });
    }
  },
}).$mount('#app');

router.beforeEach((to, from, next) => {
  // NOTE: redirect to login page if not authenticated
  const publicPages = ['/login', '/reset', '/thanks', '/healthcheck'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = store.getters.hasUser;

  if (authRequired && !loggedIn) {
    return next('/login');
  }
  else if (loggedIn) {
    Vue.http.get(`/api/users/${store.state.user}/reset`)
      .then((response) => {
        const forceLogout = response.data;

        if (!forceLogout) {
          return;
        }

        store.commit('logout');
        router.push({
          name: 'loginIndex',
          params: {
            error: 'Reporting app has been updated. Please login again to grab the latest changes.',
          },
        });
      });
  }

  next();
});
